import {FormattedSearchItem} from '../types/FormattedSearchResult';
import {RecentSearchResult} from '../types/SearchResult';
import {SearchResultVariant} from '../types/SearchResultVariant';

export interface FormattedRecent extends FormattedSearchItem {
	variant: SearchResultVariant.Recent;
}

type RecentFormatterInput = {
	searchResult: RecentSearchResult;
	handleRecentSelected: (value: string) => void;
};

export const recentFormatter = ({searchResult, handleRecentSelected}: RecentFormatterInput): FormattedRecent => {
	return {
		title: searchResult.name,
		name: searchResult.name,
		variant: searchResult.variant,
		ariaLabel: `Recent search: ${searchResult.name}`,
		onSelect: () => handleRecentSelected(searchResult.name),
	};
};
